export function getPdfTemplateTypeLabel(
  templateType: string,
  t: (key: string) => string,
): string {
  const labels: Record<string, string> = {
    fee_notice: t('feeNoticeTemplate'),
    service_fee: t('feeNoticeTemplate'),
    receipt: t('receiptTemplate'),
    ie_income_receipt: 'Phiếu thu chi (Quản lý thu chi)',
    offset_voucher: 'Cấn trừ phiếu thu',
    surplus_voucher: 'Đóng dư phiếu thu',
  };
  return labels[templateType] || templateType;
}
